import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

/**
 * OpenCart Component - Cart icon with quantity badge
 * Exactly like Vercel Commerce
 */
export default function OpenCart({
    className,
    quantity,
    variant = 'default'
}: {
    className?: string;
    quantity?: number;
    variant?: 'default' | 'minimal';
}) {
    const isMinimal = variant === 'minimal';

    return (
        <div className={clsx(
            "relative flex items-center justify-center transition-colors px-1",
            !isMinimal && "h-11 w-11 rounded-md border border-neutral-200 text-black dark:border-neutral-700 dark:text-white",
            isMinimal && "h-9 w-9 text-neutral-600 hover:text-neutral-900",
            className
        )}>
            <ShoppingCartIcon
                className={clsx(isMinimal ? 'h-5' : 'h-4', 'transition-all ease-in-out hover:scale-110')}
            />

            {quantity ? (
                <div className={clsx(
                    "absolute flex items-center justify-center rounded-full bg-primary text-[10px] font-bold text-primary-foreground",
                    isMinimal ? "top-0 right-0 h-4 w-4" : "top-0 right-0 -mr-1 -mt-1 h-5 w-5"
                )}>
                    {quantity}
                </div>
            ) : null}
        </div>
    );
}
